// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"HelpMenu_dropdownMenu__aUcT4"};